import quarters from '@/modules/quarters'

export default {
  state: {
    riskLevels: [
      'Minimal',
      'Low',
      'Medium',
      'High',
      'Critical'
    ],
    riskLevelClasses: [
      'info',
      'success',
      'warning',
      'danger',
      'danger'
    ],
    list: [],
    history: [],
    current: null,
  },
  getters: {
    riskLevels: state => state.riskLevels,
    riskLevelClasses: state => state.riskLevelClasses,
    assessmentsList: state => state.list,
    assessmentHistory: state => state.history,
    currentAssessment: state => state.current,
    currentYear: () => quarters.currentYear(),
    lastYear: () => quarters.lastYear(),
    currentQuarter: () => quarters.currentQuarter(),
  },
  mutations: {
    riskLevels (state, riskLevels: Array<string>) {
      state.riskLevels = riskLevels
    },
    assessmentsList (state, newList: Array<any>) {
      state.list = newList
    },
    assessmentHistory (state, newHist: Array<any>) {
      state.history = newHist
    },
    currentAssessment (state, assessment: Assessment) {
      state.current = assessment
    },
  },
  actions: {

    async loadAssessmentsList ({commit, getters}) {
      console.log('store.loadAssessmentsList')
      const api = getters.api
      const response = await api.get('assessments')
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not get assessments list."
        }
      }
      commit('assessmentsList', (response.data.success ? response.data.data : []))
      return response.data
    },

    async getAssessment ({commit, getters}, assessmentId: number|"default") {
      console.log('store.getAssessment')
      const api = getters.api
      const response = await api.get('assessments/'+assessmentId)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not get assessment details."
        }
      }
      commit('currentAssessment', (response.data.success ? response.data.data : null))
      return response.data
    },

    async getAssessmentHistory ({commit, getters}, customerId?: number) {
      console.log('store.getAssessmentHistory', customerId)
      const api = getters.api
      const response = await api.get('assessments/history')
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not get assessments history."
        }
      }
      commit('assessmentHistory', (response.data.success ? response.data.data : []))
      return response.data
    },

    async postAssessmentAnswers ({getters}, submission: Submission) {
      const api = getters.api
      const response = await api.post('assessments/submit', submission)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not submit assessment answers form."
        }
      }
      return response.data
    },

    async getAssessmentSubmission ({getters}, subId: number) {
      const api = getters.api
      let response: any
      if (getters.sessionUserIsBank) {
        response = await api.get(`customers/${getters.currentCustomerId}/submissions/${subId}`)
      } else if (subId) {
        response = await api.get(`assessments/submissions/${subId}`)
      } else {
        return {
          success: false,
          message: "Missing submission ID."
        }
      }
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not get previous assessment submission."
        }
      }
      return response.data
    },

    async deleteAssessmentSubmission ({getters}, subId: number) {
      const api = getters.api
      const customerId = getters.currentCustomerId
      const response = await api.delete(`customers/${customerId}/submissions/${subId}`)
      if (response.status >= 300) {
        return {
          success: false,
          message: "Could not archive previous assessment submission."
        }
      }
      return response.data
    },

  }
}
